import type { ShippingAddress } from '@ab-core/graphql/dist';
import { makeVar, useReactiveVar } from '@apollo/client';
import type { OrderLineItem, ReturnErrorState, ReturnObject, ReturnStoreType, StateType } from './types';

const _state: StateType = {
    returnErrorState: makeVar<ReturnErrorState>({}),
    orderLineItems: makeVar<OrderLineItem[] | undefined>(undefined),
    checkoutItem: makeVar<ReturnObject | undefined>(undefined),
    returnReferenceAddress: makeVar<ShippingAddress | undefined>(undefined)
};

export const returnStore: ReturnStoreType = {
    getters: {
        useReturnErrorState: () => useReactiveVar(_state.returnErrorState),
        useOrderLineItems: () => useReactiveVar(_state.orderLineItems),
        useCheckoutItem: () => useReactiveVar(_state.checkoutItem),
        useReturnReferenceAddress: () => useReactiveVar(_state.returnReferenceAddress)
    },
    setters: {
        setReturnErrorState: (state) => _state.returnErrorState(state),
        setOrderLineItems: (items) => _state.orderLineItems(items),
        setCheckoutItem: (item) => _state.checkoutItem(item),
        setReturnReferenceAddress: (address) => _state.returnReferenceAddress(address)
    }
};
